<template>
  <div>
    <intro-hero />
    <partner-logos />
    <we-want-you />
    <recent-news :posts="posts" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import IntroHero from '~/components/partners/IntroHero.vue'
import PartnerLogos from '~/components/partners/PartnerLogos.vue'
import WeWantYou from '~/components/partners/WeWantYou.vue'
import RecentNews from '~/components/RecentNews.vue'

export default {
  components: {
    IntroHero,
    PartnerLogos,
    WeWantYou,
    RecentNews
  },
  head () {
    return {
      title: 'Provide cartonization to your customers',
      meta: [
        { hid: 'description', name: 'description', content: 'Find a Paccurate-powered WMS, TMS, or OMS system. Or, add Paccurate to your software suite to supercharge your customers packing.' }
      ]
    }
  },
  computed: {
    ...mapState([
      'posts'
    ])
  }
}
</script>
